import { FC, useState } from "react";
import Container from "react-bootstrap/Container";
import { Navigate } from "react-router-dom";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { editReportVersionAccessInformationFileRoute, reportVersionAccessInformationRoute } from "app/route/Routes";
import { useRouteParams } from "app/route/route";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import { UpdateReportAccessInformationFileForm } from "app/component/report-access-information-file/UpdateReportAccessInformationFileForm.tsx";

export const EditReportVersionAccessInformationFileScreen: FC = () => {
    const { reportId, versionId, fileId } = useRouteParams(editReportVersionAccessInformationFileRoute);
    const [created, setUpdated] = useState(false);

    return created ? (
        <Navigate to={reportVersionAccessInformationRoute.build({ reportId, versionId })} />
    ) : (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={editReportVersionAccessInformationFileRoute} />
                <UpdateReportAccessInformationFileForm fileId={fileId} onUpdate={() => setUpdated(true)} />
            </Container>
        </NavigationScreen>
    );
};
